import React, { Component } from 'react'
import posed from 'react-pose'
import styles from './About.module.scss'
import { Parallax } from 'react-scroll-parallax'
import laura from './laura2.png'
import daytoday from './daytoday.jpg'
import junk from './junk.jpg'
import boxing from './boxing.jpg'
import kintohub from './kintohub.jpg'
import skiing from './skiing.jpg'

const Container = posed.div({
  enter: { staggerChildren: 50 }
})

class About extends Component {
  render() {
    return (
      <Container>
        {/* top section */}
        <div className={styles.aboutMe}>
          <div>
            <h2>
              <strong>UI Technical</strong> Artist
            </h2>

            <h2>
              Building intuitive
              <strong> player experiences</strong>.
            </h2>

            <h2>
              Somewhere between
              <strong> engineering</strong> and
              <strong> art</strong>.
            </h2>

            <h2>
              Currently exploring
              <strong> Unreal Engine</strong>,
              <strong> C++</strong> and
              <strong> ZBrush</strong>.
            </h2>

            <h2>
              Concurrently a lover of, and allergic to,
              <strong> cats</strong> and
              <strong> Nutella</strong>.
            </h2>

            <h2>
              Based in
              <strong> Singapore</strong>.
            </h2>
          </div>
          <div className={styles.imageInSvgMobile}>
            <Parallax x={[100, -100]} className={styles.border}>
              <svg height="200" width="200">
                <polygon
                  id="triangleMobile"
                  points="5, 5,190, 5, 95 , 190"
                  className={styles.path}
                  style={{
                    stroke: 'rgba(23, 190, 187, 1)',
                    strokeWidth: 5,
                    strokeLinejoin: 'round',
                    strokeLinecap: 'round',
                    fill: 'none'
                  }}
                />
              </svg>
            </Parallax>

            <img src={laura} className={styles.clipped} alt="" />

            <Parallax x={[200, -200]} className={styles.border1}>
              <svg height="300" width="300">
                <polygon
                  id="triangleTopMobile"
                  points="5, 5, 290, 5, 145, 290"
                  className={styles.path1}
                  style={{
                    stroke: 'white',
                    strokeWidth: 5,
                    strokeLinejoin: 'round',
                    strokeLinecap: 'round',
                    fill: 'none'
                  }}
                />
              </svg>
            </Parallax>
          </div>

          <div className={styles.imageInSvg}>
            <Parallax className={styles.border} x={[-80, 100]}>
              <svg height="360" width="360">
                <polygon
                  id="triangle"
                  points="5, 5, 350, 5, 175 , 350"
                  className={styles.path}
                  style={{
                    stroke: 'rgba(23, 190, 187, 1)',
                    strokeWidth: 5,
                    strokeLinejoin: 'round',
                    strokeLinecap: 'round',
                    fill: 'none'
                  }}
                />
              </svg>
            </Parallax>
            <img src={laura} className={styles.clipped} alt="" />
            <Parallax x={[0, -120]} className={styles.border1}>
              <svg height="460" width="460">
                <polygon
                  id="triangleTop"
                  points="5, 5, 450, 5, 225, 450"
                  className={styles.path1}
                  style={{
                    stroke: 'white',
                    strokeWidth: 5,
                    strokeLinejoin: 'round',
                    strokeLinecap: 'round',
                    fill: 'none'
                  }}
                />
              </svg>
            </Parallax>
          </div>
        </div>

        <div className={styles.fifth}>
          <img
            src="/images/backgroundLines.svg"
            alt="background lines"
            className={styles.arrowLine}
          />

          <div className={styles.images}>
            <Parallax x={[100, -100]}>
              <img src={daytoday} className={styles.clippedPortrait} alt="" />
              <img src={junk} className={styles.clippedInverted} alt="" />
              <img
                src={boxing}
                className={styles.clippedPortraitInverted}
                alt=""
              />
              <img src={kintohub} className={styles.clippedKinto} alt="" />
              <img src={skiing} className={styles.clippedPortrait} alt="" />
            </Parallax>
          </div>
        </div>

        <div className={styles.sectionMyLife}>
          <h1>The Details</h1>
          <div className={styles.theBorderLine}>
            <Parallax y={[100, -100]}>
              <div className={styles.line} />
            </Parallax>
          </div>
          <div className={styles.textualInformation}>
            <h4>
              After completing my MSc, I spent several years living and working abroad before discovering software engineering. What began as curiosity quickly became a career, leading me from frontend development into AAA games development.
            </h4>
            <h4>
              Today I work as a UI Technical Artist at Ubisoft Singapore, combining programming, technical art and close collaboration with artists, designers and engineers to create polished player experiences. I enjoy solving problems that sit between engineering, design and art, where technical thinking can help bring creative ideas to life.
            </h4>
            <h4>
              One of the things I enjoy most about this industry is that there is always something new to learn. Whether it's Unreal Engine, Lua, C++, AI-assisted development or character sculpting in ZBrush, I'm always looking for opportunities to broaden my skills and better understand the game development pipeline
            </h4>
            <h4>When I'm not working, I'm usually making something, playing the harp, learning something new,
              or taking on another brutally difficult Soulslike. I love hobbies that challenge me to think creatively and keep learning.
            </h4>
          </div>
        </div>
      </Container>
    )
  }
}

export default About
